import { useMemo } from 'react';
import { useNavigate, To } from 'react-router-dom';

export function useRouter() {
  const navigate = useNavigate();

  const router = useMemo(
    () => ({
      back: () => navigate(-1),
      forward: () => navigate(1),
      reload: () => window.location.reload(),
      push: (to: To) => navigate(to),
      replace: (to: To) => navigate(to, { replace: true }),
    }),
    [navigate],
  );

  return router;
}
